import { Basketball3x3IncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const InjuryPopup = new PopupBuilder('Injury', {
  incident_id: Basketball3x3IncidentId.Injury,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
